import dayjs from 'dayjs'
import { Order } from '../../store/order/types'
import { formatTradingNowDetails } from '../Activity/AlertDescription/helpers'
import styles from './Toasts.module.scss'

export const getOrderToastContents = (order: Order, boardLabel: string) => {
  const { type, size, displayPrice, spread, status, tradeTime, submitTime } =
    order
  const direction = type === 'buy' ? 'Bought' : 'Sold'
  const amount = formatTradingNowDetails(size, displayPrice, spread)
  const time = tradeTime || submitTime

  const getToastBody = () => {
    switch (status) {
      case 'accepted': {
        return (
          <p>
            You {direction} {amount}
          </p>
        )
      }
      case 'cancelled':
        return <p>Your attempt has been cancelled</p>
      case 'rejected':
        return <p>Your order has been rejected</p>
      default: {
        return null
      }
    }
  }
  return (
    <div>
      <div className={styles.toastHeader}>
        {boardLabel}
        <div>{dayjs(time).format('h:mm:ss A')}</div>
      </div>
      <div className={styles.toastBody}>{getToastBody()}</div>
    </div>
  )
}

const orderToastTypeMap: Record<string, 'success' | 'warning' | 'error'> = {
  accepted: 'success',
  cancelled: 'warning',
  rejected: 'error'
}

export const getOrderToastType = (status: string) => {
  return orderToastTypeMap[status] ?? 'info'
}
